import React, { useState, useEffect } from 'react';
import { travelerOptOut } from '../../service/travelerOptOutService';
import { CiriumWrapper } from '../../components/cirium/CiriumWrapper';
import { CiriumErrorPage } from '../../components/errors/CiriumErrorPage';
import { TravelerOptOutCard } from './TravelerOptOutCard';
import { goTo } from '../../configTdm';
import { getProperty } from "../../fsConfig";
import { TravelerProfileLogin } from '../../appRoutes';

interface OptOutResponse {
  success: boolean;
  profileExist: boolean;
}

const TravelerOptOutContainer: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [showError, setShowError] = useState(false);
  const [isOptOut, setIsOptOut] = useState(false);
  const { accountId } = getProperty('session', {});
  const urlParams = new URLSearchParams(window.location.search);
  const travelerKey = urlParams.get("travelerKey") || '';  

  useEffect(() => {
    travelerOptOut({
      travelerKey: travelerKey,
      accountId: accountId,
    })
      .then((response: OptOutResponse) => {
        if (response.success) {
          setIsOptOut(true);
        } else if (response.profileExist) {
          goTo(TravelerProfileLogin);
        }
      })
      .catch(() => setShowError(true))
      .finally(() => setLoading(false));
  }, [accountId, travelerKey]);

  let content = null;
  if (!loading) {
    if (showError) {
      content = <CiriumErrorPage />;
    } else if (isOptOut) {
      content = <TravelerOptOutCard email={travelerKey} />;
    }
  }

  return (
    <CiriumWrapper loading={loading}>{content}</CiriumWrapper>
  );
};

export default TravelerOptOutContainer;